var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuestroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M81.5513 40.5583c0 22.234-18.023 40.258-40.258 40.258-22.234 0-40.258-18.024-40.258-40.258S19.0593.3003 41.2933.3003c22.235 0 40.258 18.024 40.258 40.258"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M81.5513 40.5583c0 22.234-18.023 40.258-40.258 40.258-22.233 0-40.258-18.024-40.258-40.258S19.0603.3003 41.2933.3003c22.235 0 40.258 18.024 40.258 40.258zm-69.1407 0h-6.375m70.5157 0h-6.375M41.2935 11.675V5.3m0 70.5156v-6.375M20.8696 20.1349l-4.507-4.508m49.8615 49.862l-4.508-4.508m.0002-40.8465l4.508-4.508m-49.8625 49.862l4.508-4.508m20.4237-20.4221l9.126-23.225"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestroom);
export default __webpack_public_path__ + "static/media/guestroom.363bbf95bc15e8ded6abaa82e01cd554.svg";
export { ForwardRef as ReactComponent };